import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(public router: Router, public _authService: AuthService){

    }

    canActivate(){
        
        if(!this._authService.isAuthenticated()){
            this.router.navigate(['/']);
            return false;
        }
        
        return true;
    }
}